/* External Packages */
import 'bootstrap';

// jQuery Helper
import './scripts/jqueryLib';

/* Internal Files */
import general from './scripts/general.js';
import navigation from './scripts/navigation.js';

document.addEventListener('DOMContentLoaded', function () {
    general();
    navigation();
});
